"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var types_1 = require("../types");
var DatetimeInputControl_1 = require("../DatetimeInputControl");
var helpers_1 = require("../../../helpers");
var parseDate_1 = require("../parseDate");
var formatValue_1 = require("../formatValue");
var helpers_2 = require("../helpers");
exports.defaultDatetimeInputControlValueFormatter = function (_a) {
    var value = _a.value, withTime = _a.withTime, is12Hours = _a.is12Hours, texts = _a.texts;
    var uiTexts = __assign({ am: helpers_2.DEFAULT_TEXTS.am, pm: helpers_2.DEFAULT_TEXTS.pm }, texts);
    return value ? formatValue_1.formatValue(value, withTime, is12Hours, uiTexts) : '';
};
function createDefaultDatetimeInputControl(_a) {
    var _b = _a === void 0 ? {} : _a, valueFormatter = _b.valueFormatter, _c = _b.hasKeyboardEnter, hasKeyboardEnter = _c === void 0 ? true : _c;
    return function defaultDatetimeInputControlRenderer(_a) {
        var _b;
        var className = _a.className, control = _a.control, error = _a.error, placeholder = _a.placeholder, disabled = _a.disabled, size = _a.size, active = _a.active, actions = _a.actions, opened = _a.opened, focused = _a.focused, value = _a.value, startDatetime = _a.startDatetime, endDatetime = _a.endDatetime, _c = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _c === void 0 ? true : _c, testId = _a.testId, onChange = _a.onChange, onValueError = _a.onValueError, withTime = _a.withTime, is12Hours = _a.is12Hours, texts = _a.texts, style = _a.style, rest = __rest(_a, ["className", "control", "error", "placeholder", "disabled", "size", "active", "actions", "opened", "focused", "value", "startDatetime", "endDatetime", "hasEnterKeyStopPropagation", "testId", "onChange", "onValueError", "withTime", "is12Hours", "texts", "style"]);
        var inputValue = (_b = valueFormatter === null || valueFormatter === void 0 ? void 0 : valueFormatter({
            value: value,
            withTime: withTime,
            is12Hours: is12Hours,
            texts: texts
        })) !== null && _b !== void 0 ? _b : exports.defaultDatetimeInputControlValueFormatter({
            value: value,
            withTime: withTime,
            is12Hours: is12Hours,
            texts: texts
        });
        var _d = helpers_1.useStateValue(inputValue, [inputValue]), getValue = _d.getValue, setValue = _d.setValue;
        var _e = react_1.useState(false), hasValidationError = _e[0], setHasValidatorError = _e[1];
        var onInputChange = function (value) {
            var date = parseDate_1.parseDate(value, withTime, is12Hours);
            setValue(value);
            if (value === '') {
                setHasValidatorError(false);
                onChange === null || onChange === void 0 ? void 0 : onChange(null);
                return;
            }
            if (!date) {
                setHasValidatorError(true);
                onValueError === null || onValueError === void 0 ? void 0 : onValueError(types_1.DATETIME_INPUT_ERROR.parse);
                return;
            }
            if (date < startDatetime) {
                setHasValidatorError(true);
                onValueError === null || onValueError === void 0 ? void 0 : onValueError(types_1.DATETIME_INPUT_ERROR.ltStart);
                return;
            }
            if (date > endDatetime) {
                setHasValidatorError(true);
                onValueError === null || onValueError === void 0 ? void 0 : onValueError(types_1.DATETIME_INPUT_ERROR.gtEnd);
                return;
            }
            setHasValidatorError(false);
            onChange === null || onChange === void 0 ? void 0 : onChange(date);
        };
        var refControl = control.ref, onFocusControl = control.onFocus, onBlurControl = control.onBlur, onClickControl = control.onClick, onMouseDownControl = control.onMouseDown, onMouseUpControl = control.onMouseUp, onMouseEnterControl = control.onMouseEnter, onMouseLeaveControl = control.onMouseLeave, onKeyDownControl = control.onKeyDown, onKeyUpControl = control.onKeyUp, onKeyPressControl = control.onKeyPress;
        var changeHandler = function (value) {
            setValue(value);
            onInputChange(value);
        };
        var blurHandler = function (e) {
            if (hasValidationError) {
                setValue(inputValue);
                onChange === null || onChange === void 0 ? void 0 : onChange(value || null);
            }
            onBlurControl === null || onBlurControl === void 0 ? void 0 : onBlurControl(e);
        };
        return (react_1.default.createElement(DatetimeInputControl_1.DatetimeInputControl, __assign({}, rest, { className: className, testId: testId, readOnly: valueFormatter ? true : !hasKeyboardEnter, placeholder: placeholder, actions: actions, error: error, disabled: disabled, focused: focused, active: active, opened: opened, onChange: changeHandler, size: size, value: getValue(), hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, control: {
                ref: refControl,
                onFocus: onFocusControl,
                onBlur: blurHandler,
                onClick: onClickControl,
                onMouseDown: onMouseDownControl,
                onMouseUp: onMouseUpControl,
                onMouseEnter: onMouseEnterControl,
                onMouseLeave: onMouseLeaveControl,
                onKeyDown: onKeyDownControl,
                onKeyUp: onKeyUpControl,
                onKeyPress: onKeyPressControl
            }, style: style })));
    };
}
exports.createDefaultDatetimeInputControl = createDefaultDatetimeInputControl;
//# sourceMappingURL=defaultDatetimeInputControlRenderer.js.map